import React from 'react'
import ReactDOM from 'react-dom'
// Templates
import Note from './templates/Note'

export default function Kikutan() {
  const mainText = `
  動画内容とあわせて解説プリントをご確認ください。
  `
  const textList = [
    {
      text: '●「単語の覚え方」プリント （キクタンアプリの使い方 動画用）',
      fileName: '単語の覚え方プリント_STRAIL'
    },
  ]

  return (
    <Note
      mainText={mainText}
      textList={textList}
    />
  )
}

if (document.getElementById('how_to_kikutan')) {
  ReactDOM.render(
    <Kikutan />,
    document.getElementById('how_to_kikutan')
  )
}